import { Button, type ButtonProps } from "@design-system/Inputs/Button";
import {
    FlexCol,
    FlexRow,
    type OrientedFlexProps,
} from "@design-system/Layout/Flex";
import { Text, type TextProps } from "@design-system/Typography/Text";
import { cn } from "@design-system/Utilities";
import { type FC, type Ref } from "react";

type CardType = FC<OrientedFlexProps & { ref?: Ref<HTMLDivElement> }> & {
    Title: typeof Title;
    Description: typeof Description;
    CtaSection: typeof CtaSection;
    CtaButton: typeof CtaButton;
};

const Title: FC<TextProps & { ref?: Ref<HTMLParagraphElement> }> = (props) => {
    return <Text variant="header3" color="primary" {...props} />;
};

const Description: FC<TextProps & { ref?: Ref<HTMLParagraphElement> }> = (
    props,
) => {
    return <Text variant="body" color="primary" {...props} />;
};

const CtaSection: FC<OrientedFlexProps & { ref?: Ref<HTMLDivElement> }> = (
    props,
) => {
    return (
        <FlexRow gap="2" alignItems="center" justifyContent="end" {...props} />
    );
};

const CtaButton: FC<ButtonProps & { ref?: Ref<HTMLButtonElement> }> = (
    props,
) => {
    return <Button size="sm" {...props} />;
};

export const Card: CardType = ({ className, ...props }) => {
    return (
        <FlexCol
            p="4"
            gap="4"
            elevation="b-100"
            br="xl"
            className={cn("border border-tertiary min-w-[272px]", className)}
            {...props}
        />
    );
};

Card.Title = Title;
Card.Description = Description;
Card.CtaSection = CtaSection;
Card.CtaButton = CtaButton;
